const BackToTop = () => { 
    const scrollToTopButton = document.getElementById('back-to-top');

    // Let's set up a function that shows our scroll-to-top button if we scroll beyond the height of the initial window.
    const scrollFunc = () => {
        // Get the current scroll value
        let y = window.scrollY;
        let showAt = window.innerHeight / 2; //mostra a metà schermo
        
        if (y > showAt) {
            scrollToTopButton.classList.add("active");
        } else {
            scrollToTopButton.classList.remove("active");
        }
    };
    window.addEventListener("scroll", scrollFunc);

    const scrollToTop = () => {
        // Let's set a variable for the number of pixels we are from the top of the document.
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

        // When the button is clicked, run our ScrolltoTop function above!
    scrollToTopButton.onclick = function(e) {
        e.preventDefault();
        scrollToTop();
    }
};
export default BackToTop;